<!--仓库 批量打印条码-->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog">
    <div ref="print1" style="width: 850px;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{getTitle()}}</p>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="query-table">
        <tr class="noborder">
          <td align="right" width="60">入&nbsp;&nbsp;&nbsp;&nbsp;库：</td>
          <td width="120">
            <el-select v-model="controlData.cangkucode" placeholder="请选择" size="mini" @change="changename">
              <el-option
                v-for="item in jxcstoreData"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item.cangkucode">
              </el-option>
            </el-select>
          </td>
          <td align="right"  width="80">类&nbsp;&nbsp;别：</td>
          <td  width="160">
            <CommonTree ref="treeSeed" :inputSize="'mini'" :defineDataSource="true" @bindData="bindData"
                        :treeWidth="450"
                        :onlyShowGroupType="true" :needTopNode="false"
                        :treeHeight="300" :searchText="form.seedname"
                        @check="checktree1"></CommonTree>

          </td>
          <td width="80"> <el-button size="mini" type="success" @click.stop.prevent="showGoodDetailSel()">选择商品</el-button></td>
          <td width="120">总数:{{totalnumber}}</td>
          <td></td>
        </tr>
        <tr class="noborder">
          <td colspan="7">
            <el-table
              :data="tableData"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                type="index"
                :index="indexMethod"
                align="center"
                label="序号"
                width="50">
              </el-table-column>
              <el-table-column
                prop="seedname"
                label="商品名称"
                align="center"
                width="130"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="seedcode"
                label="编码"
                align="center"
                width="100"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="model"
                label="型号"
                width="80"
                align="center"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="color"
                label="色号"
                width="60"
                align="center"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="totalnumber"
                label="数量"
                align="center"
                width="90"
                header-align="center">
                <template slot-scope="scope">
                  <el-input style="width: 100%" size="small" v-model="scope.row.totalnumber"
                            :ref='scope.row.id'
                            onfocus="this.select()"
                            @keyup.enter.native="validateCounts(scope.row,scope.$index, $event,'')"
                            @keyup.down.native="validateCounts(scope.row,scope.$index, $event,'')"
                            @keyup.up.native="validateCounts(scope.row,scope.$index, $event,'')"
                            @change="totalNumber"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="barcodes"
                label="条码"
                align="left"
                header-align="center">
                <template slot-scope="scope">
                  <div v-for="item in scope.row.barcodes" :key="item.storegoodsbarcode">
                    {{item.storegoodsbarcode}}<i class="el-icon-close" style="cursor: pointer" @click="clearBar(item.storegoodsbarcode,scope.row)"></i>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="120">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger"
                             @click="handleDelete(scope.$index, scope.row)">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogSeeVisible = false">关 闭</el-button>
      <el-button @click="createBarcode" :loading="loading" type="primary" icon="el-icon-printer">打印条码</el-button>
      <el-button @click="createBarcodeV2" :loading="loading"  icon="el-icon-printer">25*95条码</el-button>
    </div>
    <BatchBuyFormProperties ref="batchBuyFormProperties" @afterSelectCode="afterSelectCode" :initnum="true"></BatchBuyFormProperties>
    <el-dialog title="选择打印日期" :visible.sync="pickDateVisible" width="400px" :close-on-click-modal="false" :append-to-body="true">
      <el-date-picker
        v-model="printdatestr"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="datePickerOptions"
        placeholder="请选择日期">
      </el-date-picker>
      <span style="color:#909399;font-size:12px;margin-left:10px;">最多可选到今天起30天内的日期</span>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="pickDateVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmPickDate">确 定</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>


<script>

  import {suppliers} from '@/api/set/externaldept';
  import {createGoodsbarcode} from '@/api/set/jxcgoodsbarcode';
  import {listBar,batchSave2,printBar} from '@/api/set/jxcstoregoodsbar';
  import {sortByKey} from '@/api/dateUtil';
  import {barcodePrint} from '@/api/file';
  import {getTenantSet} from '@/api/login';
  import {getRemark} from '@/plugin/ordercommon'
  import BatchBuyFormProperties from '../buyagreement/BatchBuyFormProperties'
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {listgoodsframe, getDetail, getGoodsTree} from '@/api/set/jxcgooddetail'
  import {loadSpecFrame} from '@/plugin/ordercommon'

  export default {
    name: 'Storeprintbarcode',
    data() {
      let yearnow = new Date().getFullYear()
      let monthnow = new Date().getMonth() + 1
      return {
        ssotoken:"",
        printtype:'',
        website:"",
        userInfoModel: {},
        data: '2',
        allSupply:false,
        didata: '',
        iddata: '',
        dialogFormVisible: false,
        title: "",
        index: -99,
        seedgoods: [],
        dialogSeeVisible: false,
        formLabelWidth: '120px',
        groupguid: '',
        maxyear: yearnow,
        maxmonth: monthnow,
        catattributes:{},
        remark: '',
        cangkucode: '',
        cangkuname: '',
        unitguid: "",
        column: [],
        ptableData: [],
        controlData: {cangkucode:'',cangkuname:''},
        showtitle1: "none",
        jxcstoreData: [],
        form: {  //表单数据
          unitguid: "",
          bookstr: "",
          seedcode: "",
          seedname: "",
          seedinfo: "",
        },
        tracknum: '',//供应商单号
        logisticstracknum: '',//跟踪单号
        seedcodeData: [],//选择类别后的商品
        seedcodes: '',
        pingpainame:'',
        tableData: [],
        loading: false,//防止多次提交
        totalnumber: 0,
        pcustomerserial: '',
        needPickDate: false,//tm38*68hg租户打印条码前需选择日期
        printdatestr: '',//选定的打印日期(yyyy-MM-dd)，一次打印所有条码用同一个日期
        pickDateVisible: false,//日期选择弹框
        datePickerOptions: {  //日期限制：最多未来30天，不限制过去日期
          disabledDate: (time) => {
            let today = new Date();
            today.setHours(0, 0, 0, 0);
            let maxDate = new Date(today.getTime() + 30 * 24 * 60 * 60 * 1000);
            return time.getTime() > maxDate.getTime();
          }
        }
      }

    },
    methods: {
      guid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      },
      //回车跳入下一行
      validateCounts(row, index, e ,pre) {
        var keyCode = e.keyCode || e.which || e.charCode;
        if (keyCode == 40 || keyCode === 13) {//回车，下方向键
          this.$refs[pre+row.id].blur()
          if (this.tableData.length - 1 === index) {
            index = -1
          }
          this.$refs[pre + (index + 1)].focus();
        } else if (keyCode == 38) {//上方向键
          this.$refs[pre+row.id].blur()
          if (index === 0) {
            index = this.tableData.length
          }
          this.$refs[pre + (index - 1)].focus();
        }
      },
      //给tableData 添加 id，共回车使用
      indexMethod(index) {
        this.tableData[index].id = index
        return index + 1;
      },
      clearBar(storegoodsbarcode,item) {
        for (let i in item.barcodes) {
          if (item.barcodes[i].storegoodsbarcode == storegoodsbarcode) {
            item.barcodes.splice(i, 1)
            break;
          }
        }
        item.totalnumber=item.barcodes.length
        this.totalNumber()
      },
      //购买总数
      totalNumber() {
        this.totalnumber = 0
        for (let i in this.tableData) {
          this.totalnumber = this.totalnumber + parseInt(this.tableData[i].totalnumber)
        }
      },
      //显示商品选择页面
      showGoodDetailSel() {
        if (this.seedcodeData.length == 0) {
          this.$message.error("品牌下没有商品");
          return
        }
        for (let i in this.seedcodeData) {
          this.seedcodeData[i].totalnumber = 0
        }
        //参数  true 显示库存，seedcode分类，cangkucode 仓库，seedcodeData 分类下的商品
        this.$refs.batchBuyFormProperties.initData(true, this.form.seedcode, this.controlData.cangkucode, this.seedcodeData, this.controlData.pcustomerserial)
      },
      //选择商品之后执行
      afterSelectCode(arr) {
        let count = 0;//记录当前订单是否需要弹出提示
        for (let i in arr) {
          let biaoji = 0
          for (let j in this.tableData) {
            //判读该商品是否属于
            if (this.tableData[j].seedcode == arr[i].seedcode && this.tableData[j].model == arr[i].model && this.tableData[j].color == arr[i].color) {
              biaoji = 1
              this.tableData[j].totalnumber = arr[i].totalnumber;//更新数量
              count++;
              break
            }
          }
          if (biaoji == 0) {
            this.tableData.push({
              seedcode: arr[i].seedcode,
              seedname: arr[i].seedname,
              color:arr[i].color,
              model:arr[i].model,
              categorycode: arr[i].categorycode,
              totalnumber: arr[i].totalnumber,
              formproperty: '[{}]',
              packagesize:'{"M":"'+arr[i].model+'","C":"'+arr[i].color+'"}',
              onlycode:'',
              barcodes:[]
            })
          }
        }
        //从小到大排序
        this.tableData.sort(function (a, b){
          if (a.model == b.model)
            return a.color.localeCompare(b.color);
          else
            return a.model.localeCompare(b.model);
        });
        this.totalNumber()
        // if (count > 0) {
        //   this.$message({
        //     message: "商品已存在！",
        //     type: 'info'
        //   })
        // }
      },
      //删除明细
      handleDelete(index, row) {
        this.tableData.splice(index, 1)
        this.totalNumber()
      },
      //页面标题
      getTitle() {
        let result = ""
        result += "打印条码"
        return result
      },
      checktree1(guids, names, arr) {
        if(guids.length<9)
          return;

        this.seedcodeData = []
        this.form.seedcode = guids
        this.form.seedname = names
        this.form.seedinfo = ";" + guids + "," + arr[0].parentId + ";"
        this.catattributes=arr[0].attributes;
        this.pingpainame=guids.length==12?(this.$refs.treeSeed.getNode(guids.substr(0, guids.length - 3)).label):'';

        if (this.form.seedname == "") {
          this.$message({
            message: '请选择类别',
            type: 'error'
          })
          return
        }
        listgoodsframe({
          categorycode: this.form.seedcode,
          filltemplate: '80',
        }).then(response => {
          this.seedcodeData = response.data.obj
          if (this.seedcodeData.length > 0) {
            for (let i in this.seedcodeData) {
              this.seedcodeData[i].totalnumber = 0
            }
            this.showGoodDetailSel();
          } else {
            // this.$message({
            //   message: '该系列没有备货商品',
            //   type: 'warning'
            // })
            return
          }

        }).catch((error) => {
          console.log(error)
        });

      },
      //商品树
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({onlyShowGroupType:true,categorystarts:'002;003;004;006'})
        })
      },
      //备注格式化
      getLiuYan(remark) {
        return getRemark(remark);
      },
      print1() {
        this.showtitle1 = ""
        this.$nextTick(() => {
          this.$print(this.$refs.print1)
          this.showtitle1 = "none"
        })
      },
      createBarcodeV2() {
        this.printtype = "tm25*95";
        this.doPrint();
      },
      createBarcode() {
        this.printtype=null;
        this.doPrint();
      },
      //tm38*68hg租户：打印前先选择日期（一次打印所有条码用同一个日期）
      doPrint() {
        if (!this.needPickDate) {
          this.barcodeP();
          return;
        }
        //上次选的日期超出未来30天范围时重置为今天(yyyy-MM-dd字符串可直接比较)，不限制过去日期
        let maxStr = this.dateAddDaysStr(this.todayStr(), 30);
        if (!this.printdatestr || this.printdatestr > maxStr)
          this.printdatestr = this.todayStr();
        this.pickDateVisible = true;
      },
      dateAddDaysStr(dateStr, days) {
        let d = new Date(dateStr);
        d.setDate(d.getDate() + days);
        let m = d.getMonth() + 1;
        let day = d.getDate();
        return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
      },
      confirmPickDate() {
        if (!this.printdatestr) {
          this.$message.warning('请选择打印日期！');
          return;
        }
        this.pickDateVisible = false;
        this.barcodeP();
      },
      todayStr() {
        let d = new Date();
        let m = d.getMonth() + 1;
        let day = d.getDate();
        return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
      },
      barcodeP(){
        var number = 0;
        for (let i in this.tableData) {
          var tn = this.tableData[i].totalnumber | 0;
          var scancount = this.tableData[i].barcodes.length;

          if (tn <= 0) {
            this.$message({message: '数量必须大于0！', type: 'error'})
            return;
          }
          if (tn > scancount) {
            number += tn - scancount;
          }
        }

        this.loading = true;
        var saveBar = []
        if (number > 0) {
          //获取条码
          createGoodsbarcode({number: number}).then(response => {
            if (response.data.code == 0) {
              var codePre = response.data.codepre;
              var num = response.data.num;
              //item.model + item.color + '-' +
              for (let i in this.tableData) {
                var item = this.tableData[i];
                var tn = item.totalnumber | 0;
                var scancount = item.barcodes.length;
                for (let j = 0; j < tn - scancount; j++) {
                  var bc = codePre + this.padleft((num - number + 1).toString(), 3, '0');
                  item.barcodes.push({
                    storegoodsbarcode: bc
                  });
                  var saveItem = {
                    storegoodsbarcode: bc,
                    cangkucode: this.controlData.cangkucode,
                    inordernum: 'createbarcode',
                    seedcode: item.seedcode,
                    seedname: item.seedname,
                    packagesize: item.packagesize
                  };
                  if (this.printdatestr)
                    saveItem.intime = this.printdatestr;//条码入库日期存所选日期
                  saveBar.push(saveItem);
                  number = number - 1;
                }
              }
              batchSave2({formdetails: JSON.stringify(saveBar)}).then(resSave => {//保存成功开始打印
                if (resSave.data.code == 0) {
                  this.barcodePDF();
                } else {
                  this.tableData = []
                  this.loading = false
                  this.$message({message: '条码生成失败，请重新选择！', type: 'error'})
                  return;
                }
              })
            }
          });
        } else {
          this.barcodePDF();
        }
      },
      barcodePDF() {
        var barcode = [];
        for (let i in this.tableData) {
          var item = this.tableData[i];
          for (let j in item.barcodes) {
            var bcItem = {
              barcode: item.barcodes[j].storegoodsbarcode, seedcode: item.seedcode, model: item.model, color: item.color
            };
            if (this.printdatestr)
              bcItem.date = this.printdatestr;//oplog记录打印日期，供barcodePrint复用
            barcode.push(bcItem);
          }
        }
        barcodePrint(barcode, null,this.printtype,this.printdatestr);
        this.loading = false;
      },
      padleft(ret,width,padChar) {
        while (ret.length < width) {
          ret = padChar + ret;
        }
        return ret;
      },
      show() {
        this.form.seedcode = ""
        this.form.seedname = ""
        this.tableData = []
        this.dialogSeeVisible = true;
      },
      //仓库选择后获取仓库名
      changename(val) {
        this.tableData=[]
        for (let i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode == val) {
            this.controlData.cangkuname = this.jxcstoreData[i].cangkuname;
          }
        }
      },
      getRemark(remark) {
        if (remark) {
          try {
            let temp = JSON.parse(remark)
            temp.forEach(item => {
              if (item.type == "客户留言") {
                return item.msg
              }
            })
          } catch (ex) {
          }
        }
        return ""
      },
      initData(row) {
        this.initForm();
        if (row == null)
          return;
        this.controlData.cangkucode = row.cangkucode;
        this.controlData.cangkuname = row.cangkuname;

        if (this.$refs.form1 !== undefined) {
          this.$refs.form1.resetFields();
          this.form.bookstr = ""
          this.form.seedcode = ""
          this.form.seedname = ""
          this.form.seedinfo = ""
          this.catattributes={}
        }
        this.index = -99
        this.form.seedcode = ''
        this.form.seedname = ''
      },
      initForm() {
        this.pcustomerserial=''
        this.ptableData=[]
        this.form.seedname=''
        this.form.seedcode=''
        this.form.bookstr = ""
        this.controlData.pcustomerserial = ''
        this.controlData.pcustomer =''
        this.controlData = {cangkucode: this.controlData.cangkucode}
        this.groupguid = ""
        this.column = []
        this.ssotoken = ""
        this.tableData = []
        this.unitguid = ""
        this.tracknum = ''
        this.logisticstracknum = ''
        this.loading = false
        this.totalnumber = 0
      }
    },
    mounted() {
      let temp = localStorage.getItem("hpapi_userInfoModel")
      if (temp) {
        this.userInfoModel = JSON.parse(temp);
      }
      cusandptbyind().then(response => {
        this.jxcstoreData = response.data.obj
        this.controlData.cangkucode = this.jxcstoreData[0].cangkucode;
      })
      //判断是否tm38*68hg租户：是则打印条码前需选择日期
      getTenantSet({"website": ''}).then(response => {
        let other = response.data.other;
        if (other && other.frameewmsize == "tm38*68hg") {
          this.needPickDate = true;
        }
      })

    },

    components: {
      BatchBuyFormProperties,
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }

  .gray1 td {
    color: #C0C4CC;
    background-color: #ebeef5;
  }

  .gray1 input {
    display: none;
  }

</style>





// WEBPACK FOOTER //
// src/components/testorder/warehouse/Storeprintbarcode.vue